import { ModalCloseButton } from './Button';

export { ModalCloseButton as ModalButton };
